import { getModuleFederatedName, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import serviceNames, { SearchService } from '~setup/SearchService';
import {
    SEARCH_RESULTS,
    SEARCH_GNAV_INPUT_FIELD,
    VOICE_SEARCH
} from '@estee/elc-service-view-names';

import './exported/search-gnav-input-field/index';
import './exported/search-results/index';
import './exported/voice-search/index';

setupServiceInfo(__serviceInfo__);
const { name, version } = __serviceInfo__;

SearchService.setViews(name, getModuleFederatedName(name), version, [
    SEARCH_RESULTS,
    SEARCH_GNAV_INPUT_FIELD,
    VOICE_SEARCH
]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('~setup/diContainer'),
    serviceKey: serviceNames.searchService
});
